<template>
  <div class="results-content-block">
    <div v-if="hotels.length === 0" class="text-center">
      <p>
        Siamo spiacenti! Non ci sono risultati per la ricerca effettuata.<br>
        Prova a cambiare i criteri di ricerca.
      </p>
    </div>
    <dynamic-scroller
        page-mode
        ref='results-scroller'
        :items="hotels"
        :item-size="null"
        :min-item-size="100"
        key-field="hotel_id">
      <template v-slot="{ item, index, active }">
        <dynamic-scroller-item
          class="pb-4"
          :item="item"
          :data-index="index"
          :active="active">
          <pad :hotel="item" />
        </dynamic-scroller-item>
      </template>
    </dynamic-scroller>
  </div>
</template>

<script>
import Pad from '@booking/components/blocks/pad.vue'

export default {
  name: "results-content-block",

  components: {
    'pad': Pad
  },

  props: {
    hotels: {
      type: Array,
      default: () => { return [] }
    }
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>
</style>